import React from 'react'
import { useSelector } from 'react-redux'
import { setShowResetPassword } from '../../redux/auth/actions'

const styles = {
    link: {
        color: '#1BAAF1',
        cursor: 'pointer',
    },
    signUpButton: {
        marginLeft: 5,
    },
    signUpLink: {
        display: 'block',
        marginTop: '3em',
        textAlign: 'center',
    },
}

const Footer = ({ onStateChange }) => {
    const showResetPassword = useSelector((state) => state.auth.showResetPassword)

    return (
        <>
            <span onClick={() => setShowResetPassword(!showResetPassword)} style={styles.link}>
                {showResetPassword ? 'Back to Sign In' : 'Forgot Password?'}
            </span>
            {/* <span style={styles.signUpLink}>
                Don't have an account?
                <span
                    onClick={() => onStateChange('signUp', {})}
                    style={{ ...styles.signUpButton, ...styles.link }}
                >
                    Sign Up
                </span>
            </span> */}
        </>
    )
}

export default Footer
